export default "__VITE_ASSET__bBpvoLqD__"